var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.45,
    y: 4.45,
    width: 21.1,
    height: 15.1,
    rx: 1.55,
    stroke: "#7C4095",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17752 9.01772C6.00987 9.19374 5.15081 10.2834 5.25923 11.4527C5.34264 12.3873 6.02238 13.2003 6.9148 13.4392C7.21922 13.523 7.84058 13.5188 8.12415 13.435C8.67044 13.2716 9.22925 12.8231 9.4878 12.3412C9.83809 11.679 9.83809 10.8408 9.48363 10.1744C9.22091 9.67989 8.62457 9.20212 8.09913 9.06801C7.84892 9.00515 7.41522 8.98 7.17752 9.01772ZM8.05326 10.0697C9.06244 10.5726 9.04993 11.964 8.03657 12.4501C7.69879 12.6094 7.26926 12.6052 6.93565 12.4334C5.91395 11.9137 5.98484 10.451 7.05241 10.0236C7.34015 9.9104 7.77385 9.92716 8.05326 10.0697Z",
    fill: "#7C4095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.75H18",
    stroke: "#7C4095",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12H18",
    stroke: "#7C4095",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.75L18 16.75",
    stroke: "#7C4095",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.fea0f75b62341c5d2cd44a52cf419e1d.svg";
export { ForwardRef as ReactComponent };